import { FormControl, FormGroup } from '@angular/forms';

export class DiagnosticsFormGroupService {
  formGroup: FormGroup<Record<string, FormControl<string>>>;

  constructor() {
    this.formGroup = new FormGroup({});
    this.formGroup.reset();
  }

  addFormControl(name: string, form: FormControl<string>): void {
    this.formGroup.addControl(name, form);
  }

  removeFormControl(name: string): void {
    this.formGroup.removeControl(name);
  }

  isFormGroupValid(): boolean {
    return this.formGroup.valid;
  }
}
